import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import VectorSource from "ol/source/Vector";
import {GeoJSON} from "ol/format";
import VectorLayer from "ol/layer/Vector";
import {Fill, Icon, Stroke, Style} from "ol/style";
import RedPinIcon from "./icons/red_pin_icon_16.png"
import {buffer} from "ol/extent";
import {unByKey} from "ol/Observable";
import {getVectorContext} from "ol/render";
import {easeOut} from "ol/easing";
import CircleStyle from "ol/style/Circle";
import {FullScreen, defaults as defaultControls, ZoomToExtent} from 'ol/control';
import ClearSelectionControl from "./controls/ClearSelection";

class OLMapController {
    map = null
    overlayLayers = {};
    baseLayer = null;

    initMap(target) {
        this.map = new Map({
            controls: defaultControls().extend([new FullScreen(),
                new ZoomToExtent({
                    extent: [
                        7031250.271849444,
                        2217134.3474655207,
                        8415677.728150556,
                        4922393.652534479
                    ]
                }),
                new ClearSelectionControl({mapCtrl: this})
            ]),
            view: new View({
                center: [7723464, 3569764],
                zoom: 5
            }),
        });
        this.addBaseLLayer();
        this.addSelectionLayer();
    }

    setTarget(target) {
        this.map.setTarget(target);
        setTimeout(() => this.map.updateSize(), 2000);

    }

    zoomToFullExtent() {
        const extent = [7031250.271849444, 2217134.3474655207, 8415677.728150556, 4922393.652534479]
        this.map.getView().fit(extent, this.map.getSize());
    }

    addBaseLLayer() {
        this.baseLayer = new TileLayer({
            source: new OSM({
                wrapX: false,
            }),
        });
        this.map.addLayer(this.baseLayer)
    }

    addSelectionLayer() {
        const title = "sel_layer";
        const vectorLayer = new VectorLayer({
            title: title,
            source: new VectorSource(),
            style: new Style({
                image: new CircleStyle({
                    radius: 10,
                    fill: new Fill({color: 'yellow'}),
                    stroke: new Stroke({
                        color: [0, 0, 0], width: 3
                    })
                })
            })
        });
        this.addOverlayLayer(vectorLayer, title)
    }

    getSelectionLayer() {
        return this.overlayLayers["sel_layer"]
    }

    getIconStyle() {
        const iconStyle = new Style({
            image: new Icon({
                anchor: [0.5, 15],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: RedPinIcon
            }),
        });
        return iconStyle;
    }


    addGeoJSONLayer(geojsonObject) {
        const title = "project_location"
        const vectorSource = new VectorSource({
            features: new GeoJSON().readFeatures(geojsonObject),
        });
        const vectorLayer = new VectorLayer({
            title: title,
            source: vectorSource,
            style: (feature) => {
                return this.getIconStyle();
            }
        });
        this.addOverlayLayer(vectorLayer, title)
    }

    addOverlayLayer(layer, title) {
        this.overlayLayers[title] = layer
        this.map.addLayer(layer)
    }

    selectFeature(id) {
        // console.log("feature " + id)
        const layer = this.overlayLayers["project_location"]
        const source = layer.getSource()
        const feature = source.getFeatures().find((feature) => {
            const properties = feature.getProperties()
            if (properties.id == id)
                return feature
        })
        // this.flash(feature)
        const sel_source = this.getSelectionLayer().getSource()
        sel_source.addFeature(feature)

    }

    clearSelectedFeatures() {
        const source = this.getSelectionLayer().getSource()
        source.clear()
    }

    zoomToSelectedFeatures() {
        const layer = this.getSelectionLayer()
        const extent = buffer(layer.getSource().getExtent(), 20 * 1000)
        // console.log("extent", extent)
        extent && this.map.getView().fit(extent, this.map.getSize());

    }

    flash(feature) {
        const duration = 3000;
        const start = Date.now();
        const flashGeom = feature.getGeometry().clone();
        const listenerKey = this.baseLayer.on('postrender', animate);

        function animate(event) {
            const frameState = event.frameState;
            const elapsed = frameState.time - start;
            if (elapsed >= duration) {
                unByKey(listenerKey);
                return;
            }
            const vectorContext = getVectorContext(event);
            const elapsedRatio = elapsed / duration;
            // radius will be 5 at start and 30 at end.
            const radius = easeOut(elapsedRatio) * 25 + 5;
            const opacity = easeOut(1 - elapsedRatio);

            const style = new Style({
                image: new CircleStyle({
                    radius: radius,
                    stroke: new Stroke({
                        color: 'rgba(255, 0, 0, ' + opacity + ')',
                        width: 0.25 + opacity,
                    }),
                }),
            });

            vectorContext.setStyle(style);
            vectorContext.drawGeometry(flashGeom);
            // tell OpenLayers to continue postrender animation
            this.map.render();
        }
    }
}

export default OLMapController;
